import TopNav from '@/components/TopNav';
import Footer from '@/components/Footer';
import { useAuth } from '@/contexts/AuthContext';

const TermsOfService = () => {
  const { user, signOut } = useAuth();

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <TopNav user={user} onLogout={signOut} />
      <main className="flex-1 container mx-auto max-w-3xl px-4 py-10 sm:py-14">
        <h1 className="text-3xl sm:text-4xl font-bold mb-2">Terms of Service</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: March 28, 2026</p>

        <div className="space-y-8 text-[15px] leading-relaxed text-foreground/90">
          <section>
            <h2 className="text-xl font-semibold mb-2">1. Acceptance of Terms</h2>
            <p>By accessing or using IgniteAiTool's translation service at translator.aiapps.tools, you agree to be bound by these Terms of Service. If you do not agree, please do not use the service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">2. Description of Service</h2>
            <p>IgniteAiTool provides an AI-powered translation service that supports text and image-based translation across multiple languages. The service is available via our web application and optional Chrome browser extension.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">3. Free Trial &amp; Usage Limits</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>New users receive a free trial of <strong>10 translation requests</strong>.</li>
              <li>After the trial is exhausted, a paid subscription is required to continue using the service.</li>
              <li>Trial limits are enforced per account and per device to prevent abuse.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">4. Account Responsibilities</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>You are responsible for maintaining the security of your account credentials.</li>
              <li>You must provide accurate information when registering.</li>
              <li>You may not create multiple accounts to circumvent trial limits.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">5. Prohibited Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-6 space-y-1 mt-1">
              <li>Abuse, exploit, or circumvent the free trial system.</li>
              <li>Use the service for unlawful, harmful, or malicious purposes.</li>
              <li>Attempt to reverse-engineer, scrape, or interfere with the service.</li>
              <li>Submit content that is illegal, defamatory, or violates third-party rights.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">6. Termination</h2>
            <p>We reserve the right to suspend or terminate your access at any time if we detect abuse, fraudulent activity, or violation of these terms. Blocked users may lose access to their account and any remaining trial or subscription benefits.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">7. Limitation of Liability</h2>
            <p>IgniteAiTool is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the service, including but not limited to inaccurate translations, service interruptions, or data loss.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">8. Changes to Terms</h2>
            <p>We may update these Terms of Service from time to time. Continued use of the service constitutes acceptance of the revised terms.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">9. Contact Us</h2>
            <p>If you have questions about these Terms, please contact us at{' '}
              <a href="mailto:ansontansv@gmail.com" className="text-primary hover:underline">ansontansv@gmail.com</a>.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
